import {
  ChecklistsListMetadata,
  ChecklistsListMetadataArgs,
  getChecklistsListMetadata,
} from '../assets/ts/data/checklists-metadata'
import useServerData from './use-server-data'

function useChecklistsMetadata(fetchArgs, waitOnParentDependency = false) {
  const {
    data: checklistsMetadata,
    error: checklistsMetadataError,
    fetchData: fetchChecklistsMetadata,
    isLoading: checklistsMetadataIsLoading,
  } = useServerData<ChecklistsListMetadata, ChecklistsListMetadataArgs>(
    getChecklistsListMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    checklistsMetadata,
    checklistsMetadataError,
    checklistsMetadataIsLoading,
    fetchChecklistsMetadata,
  }
}

export default useChecklistsMetadata
